import React, { useState } from 'react';
import { Formik } from 'formik';
import { Navigate } from 'react-router-dom';
import { Container, Row, Col, Form, Accordion, Card } from 'react-bootstrap';
import {
  AccordionDownArrow,
  AccordionUpArrow,
  AccordionBlueUpArrow,
} from '../../img/findcare/FindCareSVG';
import { HorizontalDivider } from 'src/Admin/components/common/HorizontalDivider';
import PersonalInformationViewPanel from '../User/PersonalInformationView';
import Button from '../common/button';
import BrokerViewPanel from '../User/Personas/Brokers/BrokerView';
import AutoSuggestionSelectComponent from '../../components/common/AutoSuggestSelect/Select';
import ViewEmpAndInsurerPanel from './ViewEmpAndInsurer';
import ListWithShowMoreLess from '../common/ListWithShowMoreLess';
import FacilitiesViewListItem from '../User/Personas/Providers/Facility/FacilitiesViewListItem';
import DoctorViewPanel from '../User/Personas/Providers/Doctors/DoctorView';

const AccountInfo = ({
  schema,
  currentStep,
  nextStep,
  userData,
  formData,
  handleInput,
  countryCodeList,
  serverError,
}) => {
  console.log('Form Data :::::::::: >>>>>>>>>>>> ::::::::::::  ', formData);
  const {
    lastName,
    email,
    firstName,
    middleName,
    UserType,
    brokerDetails,
    SuperUser,
    is_doctorfacility,
  } = formData;
  const userName =
    (firstName || '') + ' ' + (middleName || '') + ' ' + (lastName || '');

  const [activeId, setActiveId] = useState(0);

  const [showMoreFacilities, setShowMoreFacilities] = useState(false);

  const toggleActive = (id) => {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };

  const getUserType = () => {
    const persona =
      UserType === 'Broker'
        ? 'Broker(s)'
        : UserType === 'Client'
        ? 'Employers'
        : UserType === 'Insurer'
        ? SuperUser
          ? 'Super Admin'
          : 'Insurer'
        : 'Provider';
    console.log('persona :::::::::::::  ', persona);
    return persona;
  };

  const getSelectedEmp = () => {
    console.log('formData :::: getselected data ::::: >>> ::: ', formData);
    const empName = [];
    if (formData.mappedenties) {
      formData.mappedenties.map((b) =>
        b.Client.map((client) => empName.push(client.ClientName)),
      );
    }
    return empName;
  };

  const getSelectedFacilities = () => {
    const facilities = [];
    if (formData.userprovideraffiliationdetails) {
      formData.userprovideraffiliationdetails.map((u) =>
        u.FacilityDetails.map((f) => facilities.push(f)),
      );
    }
    return facilities;
  };

  const getSelectedDoctors = () => {
    const filterDoctors = [];
    if (formData.userprovideraffiliationdetails) {
      formData.userprovideraffiliationdetails.map((doc) => {
        doc.FacilityDetails.map((d) => {
          d.PhysicianDetails.map((p) => {
            filterDoctors.push(p);
          });
        });
      });
      return filterDoctors;
    }
  };

  console.log('getSelectedFacilities()=====', getSelectedFacilities());

  const getSelectedDoctorsByFacilities = () => {
    let tempObj = {};
    if (formData.userprovideraffiliationdetails) {
      formData.userprovideraffiliationdetails.forEach((u) => {
        u.FacilityDetails.forEach((f) => {
          const obj = { [u.FacilityOid]: f.PhysicianDetails };
          tempObj = Object.assign({ ...tempObj }, obj);
          console.log('tempObj======', tempObj);
        });
      });
    }
    return tempObj;
  };

  console.log(
    'getSelectedDoctorsByFacilities()=====',
    getSelectedDoctorsByFacilities(),
  );

  const formatPhone = (e) => {
    const target = e.target;
    const input = e.target.value.replace(/\D/g, '').substring(0, 10);
    const first = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);
    if (input.length > 6) {
      target.value = `${first}-${middle}-${last}`;
    } else if (input.length > 3) {
      target.value = `${first}-${middle}`;
    } else if (input.length > 0) {
      target.value = `${first}`;
    }
  };

  if (serverError) {
    return <Navigate to="/admin/server-error" push={true}></Navigate>;
  }

  const RenderFacilitiesListItem = ({ data, index }) => {
    return (
      <FacilitiesViewListItem
        data={data}
        index={index}
        selectedDoctors={getSelectedDoctorsByFacilities()}
        allowDoctorSelection={false}
        showDoctorTrashIcon={false}
      />
    );
  };

  return currentStep === 1 ? (
    <Container className="account-info-container column-section-left">
      <Row className="mb-4">
        <Col md={12}>
          <div className="mb-4">
            <div className="title">Verify</div>
            <p>
              To make your account secure, please create a new password to
              replace the temporary password you were given by the Javelina
              Admin, along with other details.
            </p>
          </div>
          <HorizontalDivider />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Formik
            validationSchema={schema}
            initialValues={{
              contactNumber: '',
              jobTitle: '',
              address: '',
              employeeId: '',
            }}
            enableReinitialize
            onSubmit={(values) => {
              console.log('ACCOUNT INFO VALUES ====>', values);
              nextStep();
            }}
          >
            {({
              values,
              touched,
              errors,
              status,
              handleSubmit,
              handleChange,
              handleBlur,
              setStatus,
              setFieldValue,
              setFieldTouched,
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col>
                      <PersonalInformationViewPanel
                        firstName={firstName}
                        lastName={lastName}
                        userName={userName}
                        userEmail={email}
                        userType={UserType}
                        userTypeLabel={getUserType()}
                      />
                      {(UserType === 'Broker' || UserType === 'Client') && (
                        <Accordion defaultActiveKey="0">
                          <Card>
                            <Accordion.Toggle
                              as={Card.Header}
                              onClick={() => toggleActive(0)}
                              className="panel-toggle text-left w-100"
                              eventKey="0"
                            >
                              <div className="d-flex panel-card-header">
                                <div>
                                  <span className="accordion-arrow">
                                    {activeId === 0 ? (
                                      <AccordionUpArrow className="acc-arrow" />
                                    ) : (
                                      <AccordionDownArrow className="acc-arrow" />
                                    )}
                                  </span>
                                  <span className="accordion-name">
                                    {getUserType()}
                                  </span>
                                </div>
                              </div>
                            </Accordion.Toggle>

                            <Accordion.Collapse eventKey="0">
                              <Card.Body>
                                {UserType === 'Broker' ? (
                                  <BrokerViewPanel
                                    selectedBrokers={brokerDetails}
                                  />
                                ) : (
                                  <ViewEmpAndInsurerPanel
                                    data={getSelectedEmp()}
                                  />
                                )}
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      )}

                      {UserType === 'Provider' && (
                        <Accordion defaultActiveKey="0">
                          <Card>
                            <Accordion.Toggle
                              as={Card.Header}
                              onClick={() => toggleActive(0)}
                              className="panel-toggle text-left w-100"
                              eventKey="0"
                            >
                              <div className="d-flex panel-card-header">
                                <div>
                                  <span className="accordion-arrow">
                                    {activeId === 0 ? (
                                      <AccordionUpArrow className="acc-arrow" />
                                    ) : (
                                      <AccordionDownArrow className="acc-arrow" />
                                    )}
                                  </span>
                                  <span className="accordion-name">
                                    {getUserType()}
                                  </span>
                                </div>
                              </div>
                            </Accordion.Toggle>

                            <Accordion.Collapse eventKey="0">
                              <Card.Body>
                                {is_doctorfacility && (
                                  <Accordion>
                                    <ListWithShowMoreLess
                                      data={getSelectedFacilities()}
                                      RenderItemComponent={
                                        RenderFacilitiesListItem
                                      }
                                      showMore={showMoreFacilities}
                                      setShowMore={setShowMoreFacilities}
                                      showMoreLabel={'Facilities'}
                                    />
                                  </Accordion>
                                )}
                                {!is_doctorfacility && (
                                  <DoctorViewPanel
                                    selectedDoctors={getSelectedDoctors()}
                                  />
                                )}
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="additional-info-heading-container">
                        <div className="additional-info">
                          Additional Information
                        </div>
                        <div className="additional-info-subtitle">
                          Please add the additional information in the
                          designated fields to complete your onboarding
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col sm={6}>
                      <Form.Group className="mb-4">
                        <Form.Label className="mb-0">Contact Number</Form.Label>
                        <div className="d-flex">
                          <div className="countrycode-width">
                            <AutoSuggestionSelectComponent
                              options={countryCodeList}
                              name="countryCode"
                              defaultValue={formData.countryCode}
                              //placeholder="Select Country Code"
                              components={{ IndicatorSeparator: () => null }}
                              //value={values.countryCode}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              fieldTouch={setFieldTouched}
                              isSearchable={false}
                              inputClassName={
                                touched.countryCode && errors.countryCode
                                  ? 'select-invalid-error'
                                  : ''
                              }
                              isRequired={true}
                              isInvalid={
                                touched.countryCode && errors.countryCode
                              }
                              isDisabled={true}
                            />
                          </div>
                          <div className="contact-number">
                            <Form.Control
                              type="text"
                              name="contactNumber"
                              placeholder=""
                              className={
                                errors && errors.contactNumber
                                  ? 'is-invalid'
                                  : ''
                              }
                              value={formData.contactNumber}
                              isInvalid={errors.contactNumber}
                              maxLength={12}
                              onKeyUp={(e) => formatPhone(e)}
                              onChange={(e) => {
                                handleInput(e, setFieldValue, handleChange);
                              }}
                              onBlur={(e) => {
                                handleInput(e, setFieldValue, handleChange);
                              }}
                            />
                            {status && status.contactNumber ? (
                              <Form.Control.Feedback
                                type="invalid"
                                className="mt-1"
                              >
                                <span>{status.contactNumber}</span>
                              </Form.Control.Feedback>
                            ) : (
                              errors.contactNumber && (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1"
                                >
                                  <span>{errors.contactNumber}</span>
                                </Form.Control.Feedback>
                              )
                            )}
                          </div>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group className="mb-4">
                        <Form.Label className="mb-0">Job Title/Role</Form.Label>
                        <Form.Control
                          type="text"
                          name="jobTitle"
                          placeholder=""
                          className={
                            status && status.jobTitle ? 'is-invalid' : ''
                          }
                          value={formData.jobTitle}
                          isInvalid={errors.jobTitle}
                          onChange={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          onBlur={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                        />
                        {status && status.jobTitle ? (
                          <Form.Control.Feedback
                            type="invalid"
                            className="mt-1"
                          >
                            <span>{status.jobTitle}</span>
                          </Form.Control.Feedback>
                        ) : (
                          errors.jobTitle && (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>{errors.jobTitle}</span>
                            </Form.Control.Feedback>
                          )
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <Form.Group className="mb-4">
                        <Form.Label className="mb-0">Employee ID</Form.Label>
                        <Form.Control
                          type="text"
                          name="employeeId"
                          placeholder=""
                          className={
                            status && status.employeeId ? 'is-invalid' : ''
                          }
                          value={formData.employeeId}
                          isInvalid={errors.employeeId}
                          onChange={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          onBlur={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                        />
                        {status && status.employeeId ? (
                          <Form.Control.Feedback
                            type="invalid"
                            className="mt-1"
                          >
                            <span>{status.employeeId}</span>
                          </Form.Control.Feedback>
                        ) : (
                          errors.employeeId && (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>{errors.employeeId}</span>
                            </Form.Control.Feedback>
                          )
                        )}
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group className="mb-4">
                        <Form.Label className="mb-0">
                          Location / City / Region
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="address"
                          placeholder=""
                          className={
                            status && status.address ? 'is-invalid' : ''
                          }
                          value={formData.address}
                          isInvalid={errors.address}
                          onChange={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          onBlur={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                        />
                        {status && status.address ? (
                          <Form.Control.Feedback
                            type="invalid"
                            className="mt-1"
                          >
                            <span>{status.address}</span>
                          </Form.Control.Feedback>
                        ) : (
                          errors.address && (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>{errors.address}</span>
                            </Form.Control.Feedback>
                          )
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button type="submit" className="float-right mt-2">
                        Continue
                      </Button>
                    </Col>
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </Container>
  ) : null;
};

export default AccountInfo;
